import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject, signal } from '@angular/core';
import { ToastService } from 'angular-toastify';
import { ParkingShiftDetail } from '../../../../../core/models/finance/parking-shift.model';
import { MapperParkingShiftService } from '../../../../../core/mappers/finance/mapper-parking-shift.service';
import { ApiParkingShiftService } from '../../../../../core/services/api/finance/api-parking-shift.service';

@Component({
  selector: 'app-modal-parking-shift-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-parking-shift-detail.component.html',
  styleUrl: './modal-parking-shift-detail.component.css',
})
export class ModalParkingShiftDetailComponent implements OnInit {
  @Input({ required: true }) shiftId = 0;
  @Input({ required: true }) siteId = 0;
  @Output() close = new EventEmitter<void>();

  private readonly api = inject(ApiParkingShiftService);
  private readonly mapper = inject(MapperParkingShiftService);
  private readonly toast = inject(ToastService);

  isLoading = signal(true);
  detail = signal<ParkingShiftDetail | null>(null);

  ngOnInit(): void {
    this.loadDetail();
  }

  onClose(): void {
    this.close.emit();
  }

  formatMoney(value: number | null | undefined): string {
    if (value == null || Number.isNaN(Number(value))) return '—';
    return Number(value).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  isVarianceOk(value: number | null | undefined): boolean {
    return value === 0;
  }

  hasVarianceIssue(value: number | null | undefined): boolean {
    return value != null && value !== 0;
  }

  private loadDetail(): void {
    if (!this.shiftId || !this.siteId) {
      this.isLoading.set(false);
      this.toast.error('ข้อมูลกะไม่ครบ');
      return;
    }

    this.isLoading.set(true);
    this.api.getParkingShiftById(this.shiftId, this.siteId).subscribe({
      next: (res) => {
        this.detail.set(this.mapper.mapDetail(res));
        this.isLoading.set(false);
      },
      error: () => {
        this.detail.set(null);
        this.isLoading.set(false);
        this.toast.error('โหลดรายละเอียดกะล้มเหลว');
      },
    });
  }
}
